/**
 * Cookie consent functionality
 *
 * @author Rianne Oosthoek <rianne@click.nl>
 * @credits https://stackoverflow.com/questions/14573223/set-cookie-and-get-cookie-with-javascript
 */
window.cookie_consent = function() {
    var self = this;
    var $btn_open_cookie_consent    = $('.js-open-cookie-consent');
    var $cookie_consent_div         = $('.js-cookie-consent');
    var $body = $('body');

    self.init = function( is_cookie_consent ) {

        // If the cookie isn't set, show the cookie consent popup
        if( !is_cookie_consent ) {
            $cookie_consent_div.removeClass('hide');
            $body.addClass('u-disable-scroll');
        }

        // If clicked on 'change cookie settings', open cookie consent popup
        $btn_open_cookie_consent.click(function(e) {
            e.preventDefault();

            $cookie_consent_div.removeClass('hide');
            $body.addClass('u-disable-scroll');
        });
    };
};


// WEBPACK FOOTER //
// ./resources/assets/js/frontend/components/cookie-consent.js